module.exports = __webpack_public_path__ + "static/media/essilorluxoticca.1b9417f5.jpg";